import '../css/index.scss';
import DPlayer from './player';
console.log('\n'.concat(' %c YPlayer v', YPLAYER_VERSION, ' ').concat(GIT_HASH, ' %c  ', '\n', '\n'), 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
export default DPlayer;